import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { Route, Switch, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import classNames from 'classnames';
import { animateScroll } from 'react-scroll';

import Footer from './footer';
import DataNotice from './footer/DataNotice';
import Header from './header';
import PageBreadcrumbs from './shared/PageBreadcrumbs';
import MobileHeader from './mobile/MobileHeader';
import MobilePanel from './mobile/mobilePanel';
import theme from '../data/theme';
import BlogSideBar from './cms_components/sidebar/BlogSidebar'
import BlockSlideShow from './blocks/BlockSlideShow';

function Layout(props) {
    const {
        match,
        headerLayout,
        homeComponent,
        showslider,
        breadcrumbs,
        hasSidebar,
        sidebarPosition,
        sidebarLocation,
        footerLocation,
        sliderLocation,
        locale,
    } = props;

    const classesContainer = classNames(hasSidebar === 'true' ? 'full-margin' : '');
    const classesRow = classNames(hasSidebar === 'true' ? 'row' : '');
    const classesCol = classNames(hasSidebar === 'true' ? 'col-12 col-lg-9' : '');
    const classesMT = classNames(breadcrumbs === 'false' ? 'mt-55' : '');
    const location = useLocation();

    let title
    if (locale === 'sq') {
        title = (
            <title>{theme.name_shq}</title>
        )
    } else if (locale === 'en') {
        title = (
            <title>{theme.name_en}</title>
        )
    } else if (locale === 'sr') {
        title = (
            <title>{theme.name_sr}</title>
        )
    }

    let sidebarStart;
    let sidebarEnd;

    const sidebar = <BlogSideBar position={sidebarPosition} />;

    if (sidebarPosition === 'start') {
        sidebarStart = (
            <div className={`col-xl-3 col-lg-3 sidebar--${hasSidebar} sidebar--${sidebarLocation}`}>
                <div className={classesMT}>
                    {sidebar}
                </div>
            </div>
        );
    } else if (sidebarPosition === 'end') {
        sidebarEnd = (
            <div className={`col-xl-3 col-lg-3 sidebar--${hasSidebar} sidebar--${sidebarLocation}`}>
                <div className={classesMT}>
                    {sidebar}
                </div>
            </div>
        );
    }

    const scrollId = document.getElementById('web-content');
    const isScrolledToTop = window.scrollY < 150;

    useEffect(() => {
        const storedScrollPosition = localStorage.getItem('scrollPosition');

        if (!isScrolledToTop) {
            if (storedScrollPosition) {
                window.scrollTo(0, parseInt(storedScrollPosition, 10));
            }
        }

        if (
            location.pathname.startsWith('/Page')
            || location.pathname.startsWith('/News')
            || location.pathname.startsWith('/TableSearch')
            || location.pathname.startsWith('/TableDetails')
            || location.pathname.startsWith('/Contact')
            || location.pathname.startsWith('/Search')
        ) {
            if (scrollId) {
                setTimeout(() => {
                    const offsetValue = window.innerWidth < 768 ? 30 : 100;
                    const newPosition = scrollId.offsetTop - offsetValue;
                    animateScroll.scrollTo(newPosition, {
                        duration: 1000,
                        smooth: 'easeInOutQuart',
                    });
                    localStorage.setItem('scrollPosition', newPosition);
                }, 100);
            }
        } else if (location.pathname === '/') {
            animateScroll.scrollToTop({
                duration: 1000,
                smooth: 'easeInOutQuart',
            });
        }
    }, [location.pathname]);

    return (
        <React.Fragment>
            <Helmet>
                {title}
                <meta name="description" content={theme.fullName} />
            </Helmet>

            <ToastContainer autoClose={5000} hideProgressBar />

            <MobilePanel layout={headerLayout} />

            <div className="site">
                <header className="site__header ds-lg-none">
                    <MobileHeader />
                </header>

                <header className="site__header ds-lg-block d-none">
                    <Header layout={headerLayout} showslider={showslider} />
                </header>

                <div className="site__body">
                    <BlockSlideShow sliderLocation={sliderLocation} />
                    <div id="web-content">
                        {breadcrumbs === 'true' ? (
                            <div className={`breadcrumbs--${breadcrumbs}`}>
                                <PageBreadcrumbs />
                            </div>
                        ) : ('')}
                        <div className={classesContainer}>
                            <div className={classesRow}>
                                {sidebarStart}
                                <div className={classesCol}>
                                    <Switch>
                                        <Route exact path={`${match.path}`} component={homeComponent} />
                                    </Switch>
                                </div>
                                {sidebarEnd}
                            </div>
                        </div>
                    </div>
                </div>

                <DataNotice />

                <footer className="site__footer">
                    <Footer location={footerLocation} />
                </footer>
            </div>
        </React.Fragment>
    );
}

Layout.propTypes = {
    headerLayout: PropTypes.oneOf(['default', 'about']),
    sliderLocation: PropTypes.oneOf(['home', 'page']),
    breadcrumbs: PropTypes.oneOf(['true', 'false']),
    hasSidebar: PropTypes.oneOf(['true', 'false']),
    footerLocation: PropTypes.oneOf(['home', 'page']),
    sidebarLocation: PropTypes.oneOf('default', 'search'),
    sidebarPosition: PropTypes.oneOf(['start', 'end']),
    homeComponent: PropTypes.elementType.isRequired,
};

Layout.defaultProps = {
    headerLayout: 'default',
    sliderLocation: 'page',
    sidebarLocation: 'default',
    footerLocation: 'home',
    breadcrumbs: 'true',
    hasSidebar: 'true',
    sidebarPosition: 'end',
};
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(Layout);
